import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/layout/header/header.component';
import { AppConfig } from './app.config';
import { NavBarComponent } from './shared/layout/nav-bar/nav-bar.component';
import { NgClass } from '@angular/common';
import { ApplicationStore } from './core/services/application-store.service';
import { PvmoUserRight } from '@tribeauto/ngx-mobilite-material';
import { map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslationService } from './core/services/translation/translation.service';

@Component({
  selector: 'pvmo-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, RouterModule, HeaderComponent, NavBarComponent, NgClass]
})
export class AppComponent implements OnInit {
  private readonly translateService = inject(TranslateService);
  private readonly translationService = inject(TranslationService);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly FILE_MAP: Record<string, string> = { fr: 'b2b.fr', en: 'b2b.en' };
  readonly appConfig = inject(AppConfig);
  readonly DEFAULT_LANG = 'fr';

  private getSelectedFile(): string {
    const currentLang = this.translateService.getCurrentLang() ?? localStorage.getItem('lang') ?? this.DEFAULT_LANG;
    return this.FILE_MAP[currentLang];
  }

  isTranslationReady = toSignal(
    this.translateService.use(this.translateService.getCurrentLang() || this.DEFAULT_LANG).pipe(map(() => true)),
    { initialValue: false }
  );
  opacity = false;
  hasRightToShowNavBar = computed(() =>
    this.applicationStore
      .instant('userData')()
      ?.userRights?.some(right => right.name === PvmoUserRight.PVMO_NAVIGATION_BAR)
  );

  ngOnInit(): void {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(() => this.injectWebComponents());
    } else {
      this.injectWebComponents();
    }
  }

  private injectWebComponents(): void {
    this.translationService.selectedFile.update(() => this.getSelectedFile());
    const mobisim = document.createElement('script');
    mobisim.setAttribute('nonce', 'NGINX_CSP_NONCE');
    mobisim.setAttribute('src', this.appConfig.mobisimUrl + '/mobi-sim.js');
    mobisim.setAttribute('type', 'module');
    mobisim.setAttribute('async', 'true');
    mobisim.setAttribute('name', 'mobi-sim');
    document.getElementsByTagName('head')[0].appendChild(mobisim);

    const mobisub = document.createElement('script');
    mobisub.setAttribute('nonce', 'NGINX_CSP_NONCE');
    mobisub.setAttribute('src', this.appConfig.mobisubUrl + '/mobi-sub.js');
    mobisub.setAttribute('type', 'module');
    mobisub.setAttribute('async', 'true');
    mobisub.setAttribute('name', 'mobi-sub');
    document.getElementsByTagName('head')[0].appendChild(mobisub);

    const mobiedoc = document.createElement('script');
    mobiedoc.setAttribute('nonce', 'NGINX_CSP_NONCE');
    mobiedoc.setAttribute('src', this.appConfig.mobiedocUrl + '/mobi-edoc.js');
    mobiedoc.setAttribute('type', 'module');
    mobiedoc.setAttribute('async', 'true');
    mobiedoc.setAttribute('name', 'mobi-edoc');
    document.getElementsByTagName('head')[0].appendChild(mobiedoc);

    const mobiadmin = document.createElement('script');
    mobiadmin.setAttribute('nonce', 'NGINX_CSP_NONCE');
    mobiadmin.setAttribute('src', this.appConfig.mobiadminUrl + '/mobi-admin.js');
    mobiadmin.setAttribute('type', 'module');
    mobiadmin.setAttribute('async', 'true');
    mobiadmin.setAttribute('name', 'mobi-admin');
    document.getElementsByTagName('head')[0].appendChild(mobiadmin);
  }

  setOpacity(opacity: boolean): void {
    this.opacity = opacity;
  }
}
